
export default {
  getUser (context, vm) {
    return new Promise((resolve, reject) => {
      vm.$http.get(vm.$api.user).then(res => {
        let { status, data } = res
        if (status) {
          return vm.$h.handleError(res)
        }
        context.commit('updateUser', data)
        if (!data.zg_openid) {
          vm.$dialog.confirm({
            title: '公众号未授权',
            message: '点击确定进入公众号授权'
          }).then(() => {
            window.location.href = 'https://m.yooshifu.com/wechat/oauth'
          }).catch(() => {
            window.location.href = 'https://m.yooshifu.com/wechat/oauth'
          })
        }
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }, // end of getUser
  getGroupon (context, vm, id) {
    return new Promise((resolve, reject) => {
      vm.$http.get(vm.$api.groupons + '/' + vm.id).then(res => {
        let { status, data } = res
        if (status) {
          return vm.$h.handleError(res)
        }
        // data = {
        //   min: 2,
        //   title: '联塑电线春夏纵情抢购开团',
        //   started_at: '2019-09-09',
        //   end_at: ' 2019-09-09',
        //   ori_price: '88.88',
        //   price: '66.01',
        //   isFav: true,
        //   product_desc: '',
        //   desc: '',
        //   images: [
        //     yellow,
        //     green,
        //     blue
        //   ]
        // }
        context.commit('updateGroupon', data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  } // end of getGroupon
}
